const InfoPopupDispatcher = {
    REGO_LOOKUP: 'rego_lookup',
    VEHICLE_CONFIGURATOR: 'vehicle_configurator',
    CATALOG_FILTER_VEHICLE: 'catalog_filter_vehicle',
    CHECKOUT_STEP_ORDER: 'checkout_step_order',
    BUY_4_PAY_3: 'buy4pay3',
};

const InfoPopupContainer = 'info-popup';

export { InfoPopupDispatcher, InfoPopupContainer };